<template lang="pug">
v-container
	v-data-table(:headers="headers" :items="surveys" :items-per-page="10" no-results-text="查無資料" :search="search")
		template(v-slot:body="{items}")
			tbody
				tr(v-for="item,i in items" :key="i")
					td {{item.account}}
					td {{item.identity}}
					td {{item.route}}
					td {{item.date}}
					td {{item.time}}
					td {{item.createAt}}
					td
						v-layout
							v-btn(fab small @click="browse=item; dialog=true")
								v-icon mdi-history
							v-btn(fab small @click="removeSurvey(item.feedbackId)")
								v-icon mdi-delete
	v-layout.psf
		v-text-field(label="搜尋" v-model="search"
			:style="{width: toggle?'200px':0, transition: '0.5s'}")
		v-btn.ma-1(fab @click="toggle=!toggle")
			v-icon mdi-file-find
	v-dialog(v-model="dialog").overflow-y
		v-card.white
			v-card-title.blue.white--text {{browse.account}} - {{browse.date}} - {{browse.identity}} {{browse.route}}
			div(style="overflow-x: auto; background: white")
				table.table
					tr.blue.lighten-2.white--text
						td 問項
						td 題目
						td 類型
						td 選擇
					tr(v-for="item in browse.items" :key="item.question_tag")
						td {{item.question_tag}}
						td {{item.question_name}}
						td {{item.question_type}}
						td {{item.answer}}
</template>

<script>
import { db, shot2docs, isObject } from '../main';
import axios from 'axios';

export default {
	name: 'trace',
	data() {
		return {
			headers: [
				{ text: '帳號', value: 'account' },
				{ text: '身分', value: 'identity' },
				{ text: '路線', value: 'route' },
				{ text: '日期', value: 'date' },
				{ text: '時間', value: 'time' },
				{ text: '回填', value: 'createAt' },
				{ text: '操作' },
			],
			browse: {},
			surveys: [],
			search: '',
			toggle: false,
			dialog: false,
			page: 0,
			pageSize: 20,
		};
	},
	methods: {
		// 刪除問卷紀錄
		async removeSurvey(feedbackId) {
			const year = this.$store.state.selectedYear;

			try {
				const response = await axios.post(`/api/Questionnaire/DeleteAnswer?id=${feedbackId}&year=${year}`);
				if (response.data.status) {
					this.surveys = this.surveys.filter(x => x.feedbackId !== feedbackId);
					alert('刪除成功');
				} else {
					alert(response.data.message || '刪除失敗');
				}
			} catch (error) {
				console.error('刪除問卷錯誤:', error);
				alert('刪除失敗');
			}
		},
		// 取得問卷紀錄
		async loadSurveys() {
			const year = this.$store.state.selectedYear;

			try {
				const response = await axios.get('/api/Questionnaire/QuestionnaireAnswerList', {
					params: { year }
				});
				if (response.data.status && response.data.result) {
					this.surveys = response.data.result.map(item => ({
						feedbackId: item.feedback_id,
						date: item.fill_date ? item.fill_date.split('T')[0] : '',
						time: item.fill_time || '',
						createAt: item.created_at ? item.created_at.split('T')[0] : '',
						account: item.account || '',
						identity: item.identity_name || '',
						route: item.route_name || '',
						items: item.answers || []
					}));
				}
			} catch (error) {
				console.error('載入問卷記錄錯誤:', error);
			}
		},
	},
	// 監聽selectedYear的變化
	watch: {
		'$store.state.selectedYear'() {
			this.loadSurveys();
		},
	},
	// 初始化
	mounted() {
		this.loadSurveys();
	},
};
</script>
